import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'

import Button from '@material-ui/core/Button'

import withStyles from '@material-ui/core/styles/withStyles'

/**
 * <CompleteShowDialog show onCompleteShow = {show, comment} onCancel = {} />
 */

class CompleteShowDialog extends Component {

	state = {
		comment: ""
	}

	componentDidMount() {
		this.setState({
			comment: this.props.show.comment
		})
	}

	render() {

		return <Dialog
			open = {true}
			scroll = "body"
		>

			<DialogTitle>
				Завершить шоу
			</DialogTitle>

			<DialogContent
				style = {{
					display: "flex",
					flexDirection: "column",
				}}
			>

				<Typography className = {this.props.classes.message}>
					{this.props.show.completed.toString() === "0" ?
						`Вы уверены, что ходите завершить шоу "${this.props.show.name}" ?`
					:
						`Вы уверены, что ходите отменить завершение шоу "${this.props.show.name}" ?`
					}
				</Typography>

				<TextField
					label = "Комментарий к шоу"
					multiline
					rowsMax = "8"
					value = {this.state.comment}
					onChange = {e => {
						this.setState({
							comment: e.target.value
						})
					}}
					margin = "normal"
					variant = "outlined"
				/>

			</DialogContent>

			<DialogActions>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCompleteShow === "function") {
							this.props.onCompleteShow(this.props.show, this.state.comment)
						}
					}}
				>{this.props.show.completed.toString() === "0" ? "Завершить" : "Отменить завершение"}</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>

			</DialogActions>

		</Dialog>

	}

}

export default withStyles(theme => ({
	message: {
		marginBottom: theme.spacing.unit,
	},
}))(CompleteShowDialog)
